import { RootState } from '../reducers'

export const movieItemSelector = (state: RootState, id: number) => (state.movie ? state.movie.items[id] : null)

export const moviePagingListSelector = (state: RootState, page: number) => (state.movie ? state.movie.pages[page] : null)

export const movieListSelector = (state: RootState, page: number) => (state.movie && state.movie.pages[page] ? state.movie.pages[page].content : [])

export const lastPageMovieListSelector = (state: RootState, page: number) => (state.movie && state.movie.pages[page] ? state.movie.pages[page].last : true)
